import {
  type City,
  type CityArea,
  type ClinicBranch,
  type Doctor,
  type DoctorService,
  type Slot,
} from "@hermes/api";
import { Temporal } from "@hermes/intl";
import { type TimeSlot } from "@hermes/shared";
import { cssFns, Modal, type ModalState, Spinner } from "@hermes/ui";
import { Suspense } from "react";

import { AppointmentModalAsyncContent } from "./async-content";

export type AppointmentModalProps = {
  doctor: Pick<
    Doctor,
    | "id"
    | "slug"
    | "image_url"
    | "name"
    | "feedback_count"
    | "feedback_score"
    | "science_degree"
    | "academic_status"
    | "experience"
    | "is_active"
  >;
  city?: City;
  cityArea?: CityArea;
  branch_services: {
    branch: ClinicBranch;
    services: Pick<
      DoctorService,
      "service" | "service_name" | "service_type"
    >[];
  };
  initialSlot?: TimeSlot;
  branchSlots?: Slot[];
  state: ModalState<TimeSlot>;
  request_meta?: {
    booking_page?: string;
    list_position?: number;
  };
  startDate?: Temporal.PlainDate;
  endDate?: Temporal.PlainDate;
  initialValues?: {
    fields?: {
      name?: string;
      surname?: string;
      phone?: string;
    };
    additionalFields?: Record<string, any>;
  };
  type: "new" | "reschedule";
  onCompleted?: () => void;
  displayServices?: Pick<
    DoctorService,
    "service" | "service_name" | "service_type" | "age_to"
  >[];
  displayAllReviews?: boolean;
};

export const AppointmentModal = (props: AppointmentModalProps) => {
  return (
    <Modal
      state={props.state}
      content={
        <Suspense
          fallback={
            <div css={[cssFns.center, { minHeight: 700 }]}>
              <Spinner />
            </div>
          }
        >
          <AppointmentModalAsyncContent {...props} />
        </Suspense>
      }
    />
  );
};
